import React from "react";
import MKBox from "../components/MKBox";
import MKButton from "../components/MKButton";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PRIMARY_PINK, PRIMARY_PINK_DARK } from "../constants";

function NotAuthorized() {
  const navigate = useNavigate();
  return (
    <MKBox sx={{ p: 6, textAlign: "center" }}>
      <Typography variant="h3" color="error" mb={2}>
        Not Authorized
      </Typography>
      <Typography variant="body1" mb={4}>
        You do not have permission to access this page.
      </Typography>
              <MKButton 
          variant="contained" 
          onClick={() => navigate("/")}
          sx={{
            bgcolor: PRIMARY_PINK,
            color: '#ffffff',
            '&:hover': {
              bgcolor: PRIMARY_PINK_DARK
            }
          }}
        >
          Go Home
        </MKButton>
    </MKBox>
  );
}

export default NotAuthorized; 